// extracted by mini-css-extract-plugin
export default {"divSoloBorderDocsNaranja":"FormularioDocumentacion_divSoloBorderDocsNaranja__p-5++"};